import React from 'react';

const AudiencePlotEmptyState = (props) => (
  <svg width="164" height="141" viewBox="0 0 164 141" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="33" y="21.5" width="98" height="98" rx="6" fill="#E6F3FE" />
    <rect x="14.5" y="29" width="103" height="73" rx="5.5" fill="white" />
    <rect opacity="0.5" x="26" y="38.5" width="12" height="4" rx="2" fill="#B5DCFC" />
    <path
      d="M32.8662 61.391C32.8662 60.3846 26.3614 77.4936 26 78.5H98V51.0502C98 50.8974 97.7983 50.8424 97.7208 50.974L87.4342 68.4361L75.5088 62.733L63.5833 69.4425L53.4647 64.7458L45.5144 71.7909L32.8662 61.391Z"
      fill="url(#paint0_linear_1948_12764)"
    />
    <path
      d="M25.9767 78.3302C25.8834 78.5901 26.0184 78.8764 26.2783 78.9697C26.5382 79.0631 26.8245 78.928 26.9178 78.6681L25.9767 78.3302ZM97.9325 51.4501L98.1834 51.0176L97.3184 50.5158L97.0675 50.9483L97.9325 51.4501ZM87.4681 68.2376L87.6838 67.7865L87.4681 68.2376ZM88.0977 68.0383L87.6587 67.7989L88.0977 68.0383ZM75.7374 62.8551L75.4923 62.4193L75.7374 62.8551ZM76.1823 62.8403L75.9666 63.2914L76.1823 62.8403ZM63.8062 69.3376L63.5957 69.7911L63.8062 69.3376ZM64.2461 69.3204L64.0009 68.8847L64.2461 69.3204ZM53.6754 64.9546L53.3438 64.5804L53.6754 64.9546ZM45.6434 71.5284L45.961 71.1421L45.6434 71.5284ZM46.27 71.5168L45.9384 71.1426L46.27 71.5168ZM33.1927 61.4831L33.627 61.7308L33.1927 61.4831ZM33.4895 61.535L33.8071 61.1488L33.4895 61.535ZM26.9178 78.6681C27.0814 78.2128 28.5427 74.355 30.0766 70.4107C30.843 68.4399 31.6262 66.4511 32.273 64.8583C32.9278 63.246 33.4251 62.0846 33.627 61.7308L32.7584 61.2353C32.515 61.6619 31.9881 62.9021 31.3465 64.4821C30.697 66.0816 29.9117 68.0757 29.1446 70.0483C27.6115 73.9906 26.1453 77.8605 25.9767 78.3302L26.9178 78.6681ZM33.172 61.9212L45.3259 71.9146L45.961 71.1421L33.8071 61.1488L33.172 61.9212ZM46.6016 71.891L54.007 65.3288L53.3438 64.5804L45.9384 71.1426L46.6016 71.891ZM53.9882 65.3316L63.5957 69.7911L64.0168 68.884L54.4092 64.4245L53.9882 65.3316ZM64.4913 69.7562L75.9826 63.2909L75.4923 62.4193L64.0009 68.8847L64.4913 69.7562ZM75.9666 63.2914L87.2524 68.6886L87.6838 67.7865L76.398 62.3893L75.9666 63.2914ZM88.5367 68.2776C89.6094 66.31 94.442 57.4678 97.9325 51.4501L97.0675 50.9483C93.5694 56.9792 88.7307 65.8326 87.6587 67.7989L88.5367 68.2776ZM87.2524 68.6886C87.7167 68.9107 88.2827 68.7435 88.5367 68.2776L87.6587 67.7989C87.6594 67.7976 87.6614 67.7947 87.6649 67.792C87.668 67.7894 87.6712 67.7878 87.674 67.787C87.6798 67.7851 87.6838 67.7865 87.6838 67.7865L87.2524 68.6886ZM75.9826 63.2909C75.9777 63.2936 75.9717 63.2938 75.9666 63.2914L76.398 62.3893C76.1092 62.2511 75.7712 62.2624 75.4923 62.4193L75.9826 63.2909ZM63.5957 69.7911C63.8825 69.9242 64.2157 69.9112 64.4913 69.7562L64.0009 68.8847C64.0058 68.8819 64.0117 68.8817 64.0168 68.884L63.5957 69.7911ZM54.007 65.3288C54.0018 65.3334 53.9944 65.3345 53.9882 65.3316L54.4092 64.4245C54.0547 64.26 53.6363 64.3212 53.3438 64.5804L54.007 65.3288ZM45.3259 71.9146C45.6991 72.2214 46.24 72.2114 46.6016 71.891L45.9384 71.1426C45.9448 71.1369 45.9544 71.1367 45.961 71.1421L45.3259 71.9146ZM33.627 61.7308C33.6047 61.7699 33.544 61.8518 33.4244 61.8953C33.3072 61.9379 33.2095 61.9159 33.1673 61.9017C33.1287 61.8888 33.1112 61.8745 33.1221 61.8821C33.1307 61.888 33.1446 61.8987 33.172 61.9212L33.8071 61.1488C33.7695 61.1179 33.6404 61.0056 33.4849 60.9535C33.3914 60.9222 33.2448 60.8966 33.0827 60.9555C32.9182 61.0153 32.8165 61.1335 32.7584 61.2353L33.627 61.7308Z"
      fill="#84C5FA"
    />
    <rect x="26" y="86.5" width="6" height="6" rx="3" fill="#84C5FA" />
    <rect opacity="0.5" x="34" y="87.5" width="24" height="4" rx="2" fill="#B5DCFC" />
    <rect x="14.5" y="29" width="103" height="73" rx="5.5" stroke="url(#paint1_linear_1948_12764)" />
    <g filter="url(#filter0_d_1948_12764)">
      <rect x="46" y="38.5" width="104" height="74" rx="6" fill="white" />
      <rect opacity="0.5" x="58" y="48.5" width="24" height="4" rx="2" fill="#B5DCFC" />
      <rect x="58" y="60.5" width="80" height="6" rx="3" fill="#B5DCFC" />
      <rect x="58" y="71.5" width="56" height="6" rx="3" fill="#B5DCFC" />
      <rect x="58" y="82.5" width="32" height="6" rx="3" fill="#B5DCFC" />
      <rect x="58" y="96.5" width="6" height="6" rx="3" fill="#84C5FA" />
      <rect opacity="0.5" x="66" y="97.5" width="24" height="4" rx="2" fill="#B5DCFC" />
      <rect x="46.5" y="39" width="103" height="73" rx="5.5" stroke="url(#paint2_linear_1948_12764)" />
    </g>
    <defs>
      <filter
        id="filter0_d_1948_12764"
        x="41"
        y="33.5"
        width="116"
        height="86"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0117647 0 0 0 0 0.152941 0 0 0 0 0.270588 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1948_12764" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1948_12764" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_1948_12764"
        x1="61.7764"
        y1="50.9912"
        x2="61.7764"
        y2="78.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3AA2F8" />
        <stop offset="1" stop-color="#B5DCFC" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1948_12764"
        x1="14"
        y1="28.5"
        x2="115"
        y2="102.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5FAFF" />
        <stop offset="1" stop-color="#F5FAFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1948_12764"
        x1="46"
        y1="38.5"
        x2="147"
        y2="112.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5FAFF" />
        <stop offset="1" stop-color="#F5FAFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default AudiencePlotEmptyState;
